import { focusRing } from '../../Themes/base/focusRing';

export const tabBaseStyles = {
	':focus': focusRing,
};
